export const SET_SWAP_TOLERANCE = 'SET_SWAP_TOLERANCE'
export const SET_ADD_LIQUIDITY_TOLERANCE = 'SET_ADD_LIQUIDITY_TOLERANCE'
export const SET_REMOVE_LIQUIDITY_TOLERANCE = 'SET_REMOVE_LIQUIDITY_TOLERANCE'
export const SET_SWAP_DEADLINE = 'SET_SWAP_DEADLINE'
export const SET_ADD_LIQUIDITY_DEADLINE = 'SET_ADD_LIQUIDITY_DEADLINE'
export const SET_REMOVE_LIQUIDITY_DEADLINE = 'SET_REMOVE_LIQUIDITY_DEADLINE'
export const SET_PROMO_MODAL = 'SET_PROMO_MODAL'
export const SET_PROMO_LENGTH = 'SET_PROMO_LENGTH'
